export const getQueryString = (param: string): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
};

export const deconstructInvitationCode = (
  invitationCode: string | undefined
): {id: string; email: string} => {
  if (!invitationCode) {
    return {
      id: '',
      email: '',
    };
  }
  const [id, encodedEmail] = invitationCode.split(':');
  if (!id || !encodedEmail) {
    return {
      id: '',
      email: '',
    };
  }
  let email = '';
  try {
    email = atob(encodedEmail);
  } catch {
    email = '';
  }
  return {
    id,
    email,
  };
};

export const getSourceSite = (): string | null => {
  let sourceSite = getQueryString('ss');
  const redirect = getQueryString('redirect');
  if (!sourceSite && redirect) {
    try {
      sourceSite = new URL(redirect).searchParams.get('ss');
    } catch {
      return null;
    }
  }
  return sourceSite;
};
